import { IVisualizationNode } from '@kaoto/kaoto';

export const isRouteGroupNode = (vizNode?: IVisualizationNode): boolean =>
  vizNode?.data?.isGroup === true && vizNode.data.entity?.getRootPath() === 'route';

/** The node a vendor's payload arrives at, which is where its captured payloads belong. */
export const isVendorIngressNode = (vizNode?: IVisualizationNode): boolean => {
  const uri = (vizNode?.getNodeDefinition() as { uri?: string } | undefined)?.uri;

  return typeof uri === 'string' && uri.startsWith('platform-http');
};

/** The node that transforms the vendor's payload, which is where the mapping belongs. */
export const isTransformNode = (vizNode?: IVisualizationNode): boolean => {
  const definition = vizNode?.getNodeDefinition() as { uri?: string; to?: { uri?: string } } | undefined;
  const uri = definition?.uri ?? definition?.to?.uri;

  return typeof uri === 'string' && uri.startsWith('xslt');
};

/** The node that holds a vendor to the shape you agreed, which is where those rules belong. */
export const isVendorContractNode = (vizNode?: IVisualizationNode): boolean => {
  const definition = vizNode?.getNodeDefinition() as { uri?: string; to?: { uri?: string } } | undefined;
  const uri = definition?.uri ?? definition?.to?.uri;

  return typeof uri === 'string' && uri.startsWith('platform-contract');
};

/** The node that reshapes a tenant's documents, which is where those rules belong. */
export const isReshapeNode = (vizNode?: IVisualizationNode): boolean => {
  const definition = vizNode?.getNodeDefinition() as { uri?: string; to?: { uri?: string } } | undefined;
  const uri = definition?.uri ?? definition?.to?.uri;

  return typeof uri === 'string' && uri.startsWith('platform-reshape');
};

/** The node that wraps a document in the message its consumer expects. */
export const isWrapNode = (vizNode?: IVisualizationNode): boolean => {
  const definition = vizNode?.getNodeDefinition() as { uri?: string; to?: { uri?: string } } | undefined;
  const uri = definition?.uri ?? definition?.to?.uri;

  return typeof uri === 'string' && uri.startsWith('platform-wrap');
};

/** A DataMapper step, where everything about its mapping is done: samples, formats and files. */
export const isMappingStepNode = (vizNode?: IVisualizationNode): boolean => {
  const definition = vizNode?.getNodeDefinition() as { id?: string } | undefined;

  return (
    (typeof definition?.id === 'string' && definition.id.startsWith('kaoto-datamapper')) || isTransformNode(vizNode)
  );
};

/** A choice drawn by "Split by a field": its branches pick a kind of bill by the value of one field. */
export const isSplitChoiceNode = (vizNode?: IVisualizationNode): boolean => {
  const definition = vizNode?.getNodeDefinition() as
    | { when?: { expression?: { simple?: { expression?: unknown } } }[] }
    | undefined;

  return (
    Array.isArray(definition?.when) &&
    definition.when.some((when) =>
      /^\$\{header\.[\w-]+\} == '/.test(String(when?.expression?.simple?.expression ?? '')),
    )
  );
};

export const always = (): boolean => true;
